import { defineComponent, openBlock, createElementBlock, createElementVNode, resolveComponent, normalizeClass, normalizeStyle, withKeys, createCommentVNode, withDirectives, createVNode, vShow, toDisplayString, renderSlot, Transition, withCtx, Fragment, renderList, createBlock, withModifiers } from 'vue';

var basicPreset = {
  colors: ["#1FBC9C", "#1CA085", "#2ECC70", "#27AF60", "#3398DB", "#2980B9", "#A463BF", "#8E43AD", "#3D556E", "#222F3D", "#F2C511", "#F39C19", "#E84B3C", "#C0382B", "#DDE6E8", "#BDC3C8"],
  rowLength: 4
};

var textBasicPreset = {
  colors: ["#CC0001", "#E36101", "#FFCC00", "#009900", "#0066CB", "#000000", "#FFFFFF"],
  showBorder: true
};

var textAdvancedPreset = {
  colors: [["#000000", "#434343", "#666666", "#999999", "#b7b7b7", "#cccccc", "#d9d9d9", "#efefef", "#f3f3f3", "#ffffff"], ["#980000", "#ff0000", "#ff9900", "#ffff00", "#00ff00", "#00ffff", "#4a86e8", "#0000ff", "#9900ff", "#ff00ff"], ["#e6b8af", "#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#c9daf8", "#cfe2f3", "#d9d2e9", "#ead1dc"], ["#dd7e6b", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#a4c2f4", "#9fc5e8", "#b4a7d6", "#d5a6bd"], ["#cc4125", "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6d9eeb", "#6fa8dc", "#8e7cc3", "#c27ba0"], ["#a61c00", "#cc0000", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3c78d8", "#3d85c6", "#674ea7", "#a64d79"], ["#85200c", "#990000", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#1155cc", "#0b5394", "#351c75", "#741b47"], ["#5b0f00", "#660000", "#783f04", "#7f6000", "#274e13", "#0c343d", "#1c4587", "#073763", "#20124d", "#4c1130"]],
  borderRadius: "0",
  rowLength: 10,
  swatchSize: 24,
  spacingSize: 0
};

var script$2 = defineComponent({
  name: "v-check"
});

const _hoisted_1$2 = {
  class: "vue-swatches__check__wrapper vue-swatches--has-children-centered"
};

const _hoisted_2$2 = /*#__PURE__*/createElementVNode("div", {
  class: "vue-swatches__check__circle vue-swatches--has-children-centered"
}, [/*#__PURE__*/createElementVNode("svg", {
  version: "1.1",
  role: "presentation",
  width: "12",
  height: "12",
  viewBox: "0 0 1792 1792",
  class: "check"
}, [/*#__PURE__*/createElementVNode("path", {
  class: "vue-swatches__check__path",
  d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
})])], -1);

const _hoisted_3$2 = [_hoisted_2$2];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, _hoisted_3$2);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = "\n.vue-swatches__check__wrapper {\n\t position: absolute;\n\t width: 100%;\n\t height: 100%;\n}\n.vue-swatches__check__circle {\n\t width: 21px;\n\t height: 21px;\n\t border-radius: 50%;\n\t background-color: rgba(0, 0, 0, 0.15);\n}\n.vue-swatches__check__path {\n\t fill: white;\n}\n";
styleInject(css_248z$2);

script$2.render = render$2;

var script$1 = defineComponent({
  name: "v-swatch",
  components: {
    VCheck: script$2
  },
  props: {
    borderRadius: {
      type: String // default is calculated in `Swatches.vue`

    },
    isLast: {
      type: Boolean,
      default: false
    },
    rowLengthSetted: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean // this prop comes from computed property and always should have a value

    },
    inline: {
      type: Boolean // default is calculated in `Swatches.vue`

    },
    selected: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean // default is calculated in `Swatches.vue`

    },
    showBorder: {
      type: Boolean // default is calculated in `Swatches.vue`

    },
    showLabels: {
      type: Boolean // default is especified in `Swatches.vue`

    },
    spacingSize: {
      type: Number,
      default: 42 // this prop comes from computed property and always should have a value

    },
    swatchColor: {
      type: String,
      default: ""
    },
    swatchLabel: {
      type: String // this prop comes from computed property and always should have a value

    },
    swatchAlt: {
      type: String // this prop comes from computed property and always should have a value

    },
    swatchSize: {
      type: Number // default is especified in `Swatches.vue`

    },
    swatchStyle: {
      type: Object,
      default: () => ({}) // default is especified in `Swatches.vue`

    }
  },
  computed: {
    computedLabelStyle() {
      const offset = 8 + Math.floor(this.spacingSize / 5) * 3;
      return {
        bottom: `-${offset}px`
      };
    },

    computedSwatchStyle() {
      const baseStyles = {
        width: `${this.swatchSize}px`,
        height: `${this.swatchSize}px`,
        borderRadius: this.borderRadius,
        backgroundColor: this.swatchColor !== "" ? this.swatchColor : "#FFFFFF",
        cursor: this.cursorStyle
      };

      if (!this.inline || !this.isLast) {
        baseStyles.marginRight = `${this.spacingSize}px`;
      }

      if (this.inline && !this.rowLengthSetted) return baseStyles;
      return { ...baseStyles,
        marginBottom: `${this.spacingSize}px`
      };
    },

    cursorStyle() {
      if (this.disabled) return "not-allowed";
      return "pointer";
    },

    labelStyles() {
      return [this.computedLabelStyle];
    },

    swatchStyles() {
      return [this.computedSwatchStyle, this.swatchStyle];
    }

  }
});

const _hoisted_1$1 = ["aria-label"];
const _hoisted_2$1 = {
  key: 0,
  class: "vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"
};

const _hoisted_3$1 = /*#__PURE__*/createElementVNode("div", {
  class: "vue-swatches__diagonal"
}, null, -1);

const _hoisted_4$1 = [_hoisted_3$1];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_check = resolveComponent("v-check");

  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vue-swatches__swatch", {
      'vue-swatches__swatch--border': _ctx.showBorder,
      'vue-swatches__swatch--selected': _ctx.selected,
      'vue-swatches__swatch--is-disabled': _ctx.disabled
    }]),
    style: normalizeStyle(_ctx.swatchStyles),
    "aria-label": _ctx.swatchAlt,
    role: "button",
    tabindex: "0",
    onKeyup: _cache[0] || (_cache[0] = withKeys($event => _ctx.$emit('click', _ctx.swatchColor), ["enter"])),
    onBlur: _cache[1] || (_cache[1] = e => _ctx.$emit('blur', e.relatedTarget))
  }, [_ctx.swatchColor === '' ? (openBlock(), createElementBlock("div", _hoisted_2$1, _hoisted_4$1)) : createCommentVNode("", true), withDirectives(createVNode(_component_v_check, null, null, 512), [[vShow, _ctx.showCheckbox && _ctx.selected]]), _ctx.showLabels ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: "vue-swatches__swatch__label",
    style: normalizeStyle(_ctx.labelStyles)
  }, toDisplayString(_ctx.swatchLabel), 5)) : createCommentVNode("", true)], 46, _hoisted_1$1);
}

var css_248z$1 = "\n.vue-swatches__swatch {\n\t position: relative;\n\t display: inline-block;\n\t font-size: 0;\n}\n.vue-swatches__swatch:hover, .vue-swatches__swatch:focus {\n\t opacity: 0.9;\n\t box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.75);\n\t outline: none;\n}\n.vue-swatches__swatch.vue-swatches__swatch--border {\n\t box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.75);\n}\n.vue-swatches__swatch.vue-swatches__swatch--selected {\n\t box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.75);\n}\n.vue-swatches__swatch__label {\n\t position: absolute;\n\t left: 0;\n\t right: 0;\n\t color: #666;\n\t font-size: 10px;\n\t font-weight: bold;\n\t text-align: center;\n}\n.vue-swatches__swatch .vue-swatches__diagonal__wrapper {\n\t position: absolute;\n}\n \n";
styleInject(css_248z$1);

script$1.render = render$1;

const DEFAULT_BACKGROUND_COLOR = "#ffffff";
const DEFAULT_BORDER_RADIUS = "10px";
const DEFAULT_ROW_LENGTH = 4;
const DEFAULT_TRIGGER_CONTAINER_SPACE = 5;
const DEFAULT_SWATCH_SIZE = 42;
const DEFAULT_SHOW_BORDER = false;
const extractPropertyFromPreset = (presetName, property, alwaysReturn) => {
  if (typeof presetName !== "string") return null;else if (presetName === "text-basic") return textBasicPreset[property] === undefined ? null : textBasicPreset[property];else if (presetName === "text-advanced") return textAdvancedPreset[property] === undefined ? null : textAdvancedPreset[property];else if (presetName === "basic") return basicPreset[property] === undefined ? null : basicPreset[property];else if (alwaysReturn) return basicPreset[property] === undefined ? null : basicPreset[property];else return null;
};
var script = defineComponent({
  name: "v-swatches",
  components: {
    VSwatch: script$1
  },
  props: {
    backgroundColor: {
      type: String,
      default: DEFAULT_BACKGROUND_COLOR
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    swatches: {
      type: [Array, String],
      default: () => "basic"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fallbackInputClass: {
      type: [Array, Object, String],
      default: null
    },
    fallbackInputType: {
      type: String,
      default: () => "text",

      validator(value) {
        return ["text", "color"].indexOf(value) !== -1;
      }

    },
    fallbackOkClass: {
      type: [Array, Object, String],
      default: null
    },
    fallbackOkText: {
      type: String,
      default: "Ok"
    },
    inline: {
      type: Boolean,
      default: false
    },
    shapes: {
      type: String,
      default: "squares"
    },
    popoverX: {
      type: String,
      default: "right"
    },
    popoverY: {
      type: String,
      default: "bottom"
    },
    rowLength: {
      type: [Number, String],
      default: null // The default is especified as DEFAULT_ROW_LENGTH

    },
    showBorder: {
      type: Boolean,
      default: null // The default is especified as DEFAULT_SHOW_BORDER

    },
    showFallback: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    spacingSize: {
      type: Number,
      default: null // The default depends on swatch size

    },
    swatchSize: {
      type: [Number, String],
      default: null // The default is especified as DEFAULT_SWATCH_SIZE

    },
    swatchStyle: {
      type: [Object, Array],
      default: () => ({})
    },
    triggerStyle: {
      type: [Object, Array],
      default: () => ({})
    },
    wrapperStyle: {
      type: [Object, Array],
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      alwaysOnScreenStyle: {},
      componentMounted: false,
      internalValue: this.modelValue,
      internalIsOpen: false
    };
  },

  computed: {
    isNested() {
      if (this.computedSwatches && this.computedSwatches.length && this.computedSwatches[0] instanceof Array) {
        return true;
      }

      return false;
    },

    isOpen() {
      if (this.inline) return false;
      return this.internalIsOpen;
    },

    isNoColor() {
      return this.checkEquality("", this.modelValue);
    },

    /** REAL COMPUTEDS (depends on user's props and preset's values, these have 'computed' prefix) **/
    // Preset Computeds
    presetBorderRadius() {
      return extractPropertyFromPreset(this.swatches, "borderRadius");
    },

    presetRowLength() {
      return extractPropertyFromPreset(this.swatches, "rowLength");
    },

    presetShowBorder() {
      return extractPropertyFromPreset(this.swatches, "showBorder");
    },

    presetSwatchSize() {
      return extractPropertyFromPreset(this.swatches, "swatchSize");
    },

    presetSpacingSize() {
      return extractPropertyFromPreset(this.swatches, "spacingSize");
    },

    // Computed value for `swatches`
    computedSwatches() {
      if (this.swatches instanceof Array) return this.swatches;
      /* istanbul ignore else */

      if (typeof this.swatches === "string") {
        return extractPropertyFromPreset(this.swatches, "colors", true);
      } else {
        return [];
      }
    },

    // Computed value for `borderRadius`
    computedBorderRadius() {
      // Priorize preset value
      if (this.presetBorderRadius !== null) return this.presetBorderRadius; // over computed value

      return this.borderRadius;
    },

    // Computed value for `rowLength`
    computedRowLength() {
      // Priorize user value
      if (this.rowLength !== null) return Number(this.rowLength); // Over preset value
      else if (this.presetRowLength !== null) return this.presetRowLength; // If there are less swatches than the default
      else if (this.computedSwatches.length < DEFAULT_ROW_LENGTH && !this.isNested) return this.computedSwatches.length; // Use default otherwise

      return DEFAULT_ROW_LENGTH;
    },

    // Computed value for `swatchSize`
    computedSwatchSize() {
      // Priorize user value
      if (this.swatchSize !== null) return Number(this.swatchSize);else if (this.presetSwatchSize !== null) // over preset value
        return this.presetSwatchSize; // Use default value if these two are unset

      return DEFAULT_SWATCH_SIZE;
    },

    // Computed value for `spacingSize`
    computedSpacingSize() {
      // Priorize user value
      if (this.spacingSize !== null) return this.spacingSize; // Priorize preset value

      if (this.presetSpacingSize !== null) return this.presetSpacingSize; // over computed value

      return Math.round(this.computedSwatchSize * 0.25);
    },

    // Computed value for `showBorder`
    computedShowBorder() {
      // Priorize user value
      if (this.showBorder !== null) return this.showBorder; // over preset value

      if (this.presetShowBorder !== null) return this.presetShowBorder; // Use default value if these two are unset

      return DEFAULT_SHOW_BORDER;
    },

    showFallbackOk() {
      return !this.inline;
    },

    /** DUMB COMPUTEDS (these only mutate props) **/
    borderRadius() {
      if (this.shapes === "squares") return `${Math.round(this.computedSwatchSize * 0.25)}px`;else if (this.shapes === "circles") return `50%`;
      /* istanbul ignore next */

      return "";
    },

    wrapperWidth() {
      return this.computedRowLength * (this.computedSwatchSize + this.computedSpacingSize);
    },

    /** COMPUTED STYLES **/
    computedtriggerStyle() {
      return {
        width: "42px",
        height: "42px",
        backgroundColor: this.modelValue ? this.modelValue : "#ffffff",
        borderRadius: this.shapes === "circles" ? "50%" : DEFAULT_BORDER_RADIUS
      };
    },

    triggerStyles() {
      return [this.computedtriggerStyle, this.triggerStyle];
    },

    containerStyles() {
      const baseStyles = [{
        backgroundColor: this.backgroundColor
      }, this.alwaysOnScreenStyle];
      if (this.inline) return baseStyles;
      return [...baseStyles, {
        padding: "5px",
        marginBottom: "5px"
      }];
    },

    computedWrapperStyle() {
      if (this.inline) return {};
      return {
        paddingTop: `${this.computedSpacingSize}px`,
        paddingLeft: `${this.computedSpacingSize}px`,
        width: `${this.wrapperWidth}px`
      };
    },

    wrapperStyles() {
      return [this.computedWrapperStyle, this.wrapperStyle];
    },

    computedFallbackWrapperStyle() {
      const baseStyles = {
        marginLeft: `${this.computedSpacingSize}px`,
        paddingBottom: `${this.computedSpacingSize}px`
      };
      if (this.inline) return baseStyles;
      return { ...baseStyles,
        width: `${this.wrapperWidth - this.computedSpacingSize}px`
      };
    },

    computedFallbackWrapperStyles() {
      return [this.computedFallbackWrapperStyle];
    }

  },
  watch: {
    modelValue(newValue) {
      this.internalValue = newValue;
    }

  },

  mounted() {
    this.componentMounted = true;
  },

  methods: {
    // Called programmatically
    checkEquality(color1, color2) {
      if (!color1 && color1 !== "" || !color2 && color2 !== "") return false;
      return color1.toUpperCase() === color2.toUpperCase();
    },

    hidePopover() {
      this.internalIsOpen = false;
      this.$el.blur();
      this.$emit("close", this.internalValue);
    },

    getAlwaysOnScreenStyle() {
      const styles = {};
      const triggerEl = this.$refs.triggerWrapper;
      const containerEl = this.$refs.containerWrapper;
      /* istanbul ignore if */

      if (!this.componentMounted || this.inline || !triggerEl || !window || !document) return styles;
      const triggerRect = triggerEl.getBoundingClientRect();
      const leftMin = 5;
      const rightMax = (document.documentElement.clientWidth || window.innerWidth) - 5;
      const topMin = 5;
      const bottomMax = (document.documentElement.clientHeight || window.innerHeight) - 5;
      containerEl.style.visibility = "hidden";
      containerEl.style.display = "block";
      const containerRect = containerEl.getBoundingClientRect();
      containerEl.style.display = "none";
      containerEl.style.visibility = "visible";

      if (this.popoverY === "top") {
        if (triggerRect.top - containerRect.height < topMin) {
          // Showing bellow
          styles.top = `${triggerRect.height + DEFAULT_TRIGGER_CONTAINER_SPACE}px`;
          styles.bottom = "auto";
        } else {
          // Showing above
          styles.bottom = `${triggerRect.height + DEFAULT_TRIGGER_CONTAINER_SPACE}px`;
          styles.top = "auto";
        }
      } else {
        /* istanbul ignore else */
        if (this.popoverY === "bottom") {
          if (triggerRect.bottom + containerRect.height > bottomMax) {
            // Showing above
            styles.bottom = `${triggerRect.height + DEFAULT_TRIGGER_CONTAINER_SPACE}px`;
            styles.top = "auto";
          } else {
            // Showing bellow
            styles.top = `${triggerRect.height + DEFAULT_TRIGGER_CONTAINER_SPACE}px`;
            styles.bottom = "auto";
          }
        }
      }

      if (this.popoverX === "left") {
        if (triggerRect.right - containerRect.width < leftMin) {
          // Showing at the right
          styles.left = 0;
          styles.right = "auto";
        } else {
          // Showing at the left
          styles.right = 0;
          styles.left = "auto";
        }
      } else {
        /* istanbul ignore else */
        if (this.popoverX === "right") {
          if (triggerRect.left + containerRect.width > rightMax) {
            // Showing at the left
            styles.right = 0;
            styles.left = "auto";
          } else {
            // Showing at the right
            styles.left = 0;
            styles.right = "auto";
          }
        }
      }

      return styles;
    },

    getSwatchShowBorder(swatch) {
      if (typeof swatch === "string") return this.computedShowBorder;else if (typeof swatch === "object") return swatch.showBorder !== undefined ? swatch.showBorder : this.computedShowBorder;
    },

    getSwatchColor(swatch) {
      if (typeof swatch === "string") return swatch;else if (typeof swatch === "object") return swatch.color;
    },

    getSwatchDisabled(swatch) {
      if (typeof swatch === "string") return this.disabled;else if (typeof swatch === "object") return swatch.disabled !== undefined ? swatch.disabled : this.disabled;
    },

    getSwatchLabel(swatch) {
      if (typeof swatch === "string") return swatch;else if (typeof swatch === "object") return swatch.label || swatch.color;
    },

    getSwatchAlt(swatch) {
      if (typeof swatch === "string") return swatch;else if (typeof swatch === "object") return swatch.alt || this.getSwatchLabel(swatch);
    },

    // Called by user action
    onBlur(relatedTarget) {
      /* istanbul ignore if */
      if (!this.isOpen) return;
      /* dont hide */
      // We only close the Popover if the relatedTarget came from outside the component
      // Check if the relatedTarget is inside the component

      if (relatedTarget !== null && this.$el.contains(relatedTarget)) return;
      /* dont hide */

      this.internalIsOpen = false;
      this.$emit("close", this.internalValue);
    },

    onFallbackButtonClick() {
      this.hidePopover();
    },

    // Called programmatically
    showPopover() {
      /* istanbul ignore if */
      if (this.isOpen || this.inline || this.disabled) return;
      /* dont show */

      this.alwaysOnScreenStyle = this.getAlwaysOnScreenStyle();
      this.internalIsOpen = true;
      this.$el.focus();
      this.$emit("open");
    },

    togglePopover() {
      this.isOpen ? this.hidePopover() : this.showPopover();
    },

    updateSwatch(swatch, {
      fromFallbackInput
    } = {}) {
      if (this.getSwatchDisabled(swatch)) return;
      const color = this.getSwatchColor(swatch);
      this.internalValue = color;
      this.$emit("update:modelValue", color);

      if (this.closeOnSelect && !this.inline && !fromFallbackInput) {
        this.hidePopover();
      }
    }

  }
});

const _hoisted_1 = {
  class: "vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"
};

const _hoisted_2 = /*#__PURE__*/createElementVNode("div", {
  class: "vue-swatches__diagonal"
}, null, -1);

const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "vue-swatches__fallback__input--wrapper"
};
const _hoisted_5 = ["value", "type"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_swatch = resolveComponent("v-swatch");

  return openBlock(), createElementBlock("div", {
    class: "vue-swatches",
    tabindex: "-1",
    onBlur: _cache[5] || (_cache[5] = e => _ctx.onBlur(e.relatedTarget))
  }, [!_ctx.inline ? (openBlock(), createElementBlock("div", {
    key: 0,
    ref: "triggerWrapper",
    class: "vue-swatches__trigger__wrapper",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.togglePopover && _ctx.togglePopover(...args))
  }, [renderSlot(_ctx.$slots, "trigger", {}, () => [createElementVNode("div", {
    class: normalizeClass(["vue-swatches__trigger", {
      'vue-swatches--is-empty': !_ctx.modelValue,
      'vue-swatches--is-disabled': _ctx.disabled
    }]),
    style: normalizeStyle(_ctx.triggerStyles)
  }, [withDirectives(createElementVNode("div", _hoisted_1, _hoisted_3, 512), [[vShow, _ctx.isNoColor]])], 6)])], 512)) : createCommentVNode("", true), createVNode(Transition, {
    name: "vue-swatches-show-hide"
  }, {
    default: withCtx(() => [withDirectives(createElementVNode("div", {
      ref: "containerWrapper",
      class: normalizeClass(["vue-swatches__container", {
        'vue-swatches--inline': _ctx.inline
      }]),
      style: normalizeStyle(_ctx.containerStyles)
    }, [createElementVNode("div", {
      class: "vue-swatches__wrapper",
      style: normalizeStyle(_ctx.wrapperStyles)
    }, [_ctx.isNested ? (openBlock(true), createElementBlock(Fragment, {
      key: 0
    }, renderList(_ctx.computedSwatches, (swatchRow, index) => {
      return openBlock(), createElementBlock("div", {
        key: index,
        class: "vue-swatches__row"
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(swatchRow, (swatch, swatchIndex) => {
        return openBlock(), createBlock(_component_v_swatch, {
          key: swatchIndex,
          "is-last": index === _ctx.computedSwatches.length - 1 && swatchIndex === swatchRow.length,
          "row-length-setted": _ctx.rowLength !== null || _ctx.presetRowLength !== null,
          "border-radius": _ctx.computedBorderRadius,
          disabled: _ctx.getSwatchDisabled(swatch),
          inline: _ctx.inline,
          selected: _ctx.checkEquality(_ctx.getSwatchColor(swatch), _ctx.modelValue),
          "swatch-size": _ctx.computedSwatchSize,
          "spacing-size": _ctx.computedSpacingSize,
          "show-border": _ctx.getSwatchShowBorder(swatch),
          "show-checkbox": _ctx.showCheckbox,
          "show-labels": _ctx.showLabels,
          "swatch-color": _ctx.getSwatchColor(swatch),
          "swatch-label": _ctx.getSwatchLabel(swatch),
          "swatch-alt": _ctx.getSwatchAlt(swatch),
          "swatch-style": _ctx.swatchStyle,
          onBlur: _cache[1] || (_cache[1] = relatedTarget => _ctx.onBlur(relatedTarget)),
          onClick: [$event => _ctx.updateSwatch(swatch), $event => _ctx.updateSwatch(swatch)]
        }, null, 8, ["is-last", "row-length-setted", "border-radius", "disabled", "inline", "selected", "swatch-size", "spacing-size", "show-border", "show-checkbox", "show-labels", "swatch-color", "swatch-label", "swatch-alt", "swatch-style", "onClick"]);
      }), 128))]);
    }), 128)) : (openBlock(true), createElementBlock(Fragment, {
      key: 1
    }, renderList(_ctx.computedSwatches, (swatch, swatchIndex) => {
      return openBlock(), createBlock(_component_v_swatch, {
        key: swatchIndex,
        "is-last": swatchIndex === _ctx.computedSwatches.length - 1,
        "row-length-setted": _ctx.rowLength !== null || _ctx.presetRowLength !== null,
        "border-radius": _ctx.computedBorderRadius,
        disabled: _ctx.getSwatchDisabled(swatch),
        inline: _ctx.inline,
        selected: _ctx.checkEquality(_ctx.getSwatchColor(swatch), _ctx.modelValue),
        "swatch-size": _ctx.computedSwatchSize,
        "spacing-size": _ctx.computedSpacingSize,
        "show-border": _ctx.getSwatchShowBorder(swatch),
        "show-checkbox": _ctx.showCheckbox,
        "show-labels": _ctx.showLabels,
        "swatch-color": _ctx.getSwatchColor(swatch),
        "swatch-label": _ctx.getSwatchLabel(swatch),
        "swatch-alt": _ctx.getSwatchAlt(swatch),
        "swatch-style": _ctx.swatchStyle,
        onBlur: _cache[2] || (_cache[2] = relatedTarget => _ctx.onBlur(relatedTarget)),
        onClick: [$event => _ctx.updateSwatch(swatch), $event => _ctx.updateSwatch(swatch)]
      }, null, 8, ["is-last", "row-length-setted", "border-radius", "disabled", "inline", "selected", "swatch-size", "spacing-size", "show-border", "show-checkbox", "show-labels", "swatch-color", "swatch-label", "swatch-alt", "swatch-style", "onClick"]);
    }), 128))], 4), _ctx.showFallback ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "vue-swatches__fallback__wrapper",
      style: normalizeStyle(_ctx.computedFallbackWrapperStyles)
    }, [createElementVNode("span", _hoisted_4, [createElementVNode("input", {
      ref: "fallbackInput",
      class: normalizeClass(["vue-swatches__fallback__input", _ctx.fallbackInputClass]),
      value: _ctx.internalValue,
      type: _ctx.fallbackInputType,
      onInput: _cache[3] || (_cache[3] = e => _ctx.updateSwatch(e.target.value, {
        fromFallbackInput: true
      }))
    }, null, 42, _hoisted_5)]), _ctx.showFallbackOk ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: normalizeClass(["vue-swatches__fallback__button", _ctx.fallbackOkClass]),
      onClick: _cache[4] || (_cache[4] = withModifiers((...args) => _ctx.onFallbackButtonClick && _ctx.onFallbackButtonClick(...args), ["prevent"]))
    }, toDisplayString(_ctx.fallbackOkText), 3)) : createCommentVNode("", true)], 4)) : createCommentVNode("", true)], 6), [[vShow, _ctx.inline || _ctx.isOpen]])]),
    _: 1
  })], 32);
}

var css_248z = "\nfieldset[disabled] .vue-swatches {\n\t pointer-events: none;\n}\n.vue-swatches {\n\t position: relative;\n\t display: inline-block;\n\t outline: none;\n}\n.vue-swatches__trigger__wrapper {\n\t display: inline-block;\n\t cursor: pointer;\n}\n.vue-swatches__trigger.vue-swatches--is-empty {\n\t border: 2px solid #ccc;\n}\n.vue-swatches__trigger.vue-swatches--is-disabled {\n\t cursor: not-allowed;\n}\n.vue-swatches__container {\n\t box-sizing: content-box;\n}\n.vue-swatches__container.vue-swatches--inline {\n\t font-size: 0;\n}\n.vue-swatches__container:not(.vue-swatches--inline) {\n\t position: absolute;\n\t display: block;\n\t overflow: auto;\n\t border-radius: 5px;\n\t box-shadow: 0 2px 3px rgba(10, 10, 10, 0.2), 0 0 0 1px rgba(10, 10, 10, 0.2);\n\t z-index: 50;\n}\n.vue-swatches__wrapper {\n\t background-color: inherit;\n\t box-sizing: content-box;\n}\n.vue-swatches__row {\n\t font-size: 0;\n}\n.vue-swatches__fallback__wrapper {\n\t display: table;\n}\n.vue-swatches__fallback__input--wrapper {\n\t display: table-cell;\n\t padding-right: 10px;\n\t width: 100%;\n\t font-size: 14px;\n}\n.vue-swatches__fallback__input {\n\t width: 100%;\n\t padding-top: 6px;\n\t padding-bottom: 6px;\n\t border-radius: 5px;\n\t border: 1px solid #dcdcdc;\n\t color: #35495e;\n\t background: #fff;\n}\n.vue-swatches__fallback__button {\n\t display: table-cell;\n\t padding: 6px 15px;\n\t border: 0;\n\t cursor: pointer;\n\t font-weight: bold;\n\t color: #fff;\n\t background-color: #3571c8;\n\t border-radius: 5px;\n}\n.vue-swatches-show-hide-enter-active, .vue-swatches-show-hide-leave-active {\n\t transition: all 0.3s ease;\n}\n.vue-swatches-show-hide-enter, .vue-swatches-show-hide-leave-active {\n\t opacity: 0;\n}\n.vue-swatches--has-children-centered {\n\t display: flex;\n\t align-items: center;\n\t justify-content: center;\n}\n.vue-swatches__diagonal__wrapper {\n\t width: 100%;\n\t height: 100%;\n}\n.vue-swatches__diagonal {\n\t width: 75%;\n\t height: 75%;\n\t background: linear-gradient(to top right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) calc(50% - 2.4px), rgba(222, 8, 10, 1) 50%, rgba(0, 0, 0, 0) calc(50% + 2.4px), rgba(0, 0, 0, 0) 100%);\n}\n";
styleInject(css_248z);

script.render = render;

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('VSwatches', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
